import { gql } from '__generated__/gql';

export const PUBLIC_CLIENT_LIST_SHORT_FRAGMENT = gql(`
  fragment PublicClientListShort on HL_PublicClientOutput {
    id
    firstname
    lastname
    email
    phone
    responsibility
    isMaster
    isActive
    emailVerified
    invitationToken
    invitationTokenExpiry
    invitedAt
    confirmedAt
    publicCompany {
      id
      name
      isPremium
      isActive
    }
  }
`);

export const PUBLIC_CLIENT_LIST_FRAGMENT = gql(`
  fragment PublicClientListOutput on HL_PublicClientOutput {
    id
    firstname
    lastname
    email
    phone
    mobile
    phoneCountryCode
    mobileCountryCode
    title
    position
    responsibility
    mainLanguage
    gender
    hasAddress
    address
    addressSupplement
    zip
    city
    state
    country
    isMaster
    isActive
    emailVerified
    invitationToken
    invitationTokenExpiry
    invitedAt
    confirmedAt
    publicCompanyId
    publicCompany {
      id
      name
      isPremium
      isActive
    }
  }
`);

export const PUBLIC_COMPANY_LIST_SHORT_FRAGMENT = gql(`
  fragment PublicCompanyListShort on HL_PublicCompanyOutput {
    id
    name
    mainLanguage
    address
    zip
    city
    country
    state
    addressSupplement
    phoneCountryCode
    phone
    email
    industry
    website
    keyAccountManagerId
    keyAccountManager {
      id
      name
      email
    }
    isPremium
    isActive
    clientsCount
    showPricesInNet
    privacyPolicyAccepted
  }
`);

export const PUBLIC_CLIENT_LIST_QUERY = gql(`
  query ListPublicClients($where: PublicClientWhereInput, $skip: Int, $take: Int) {
    listPublicClients(where: $where, skip: $skip, take: $take) {
      totalCount
      clients {
        ...PublicClientListShort
      }
    }
  }
`);

export const PUBLIC_COMPANY_LIST_QUERY = gql(`
  query ListPublicCompanies($where: PublicCompanyWhereInput, $skip: Int, $take: Int) {
    listPublicCompanies(where: $where, skip: $skip, take: $take) {
      totalCount
      companies {
        ...PublicCompanyListShort
      }
    }
  }
`);

export const SUDO_CLIENT_MUTATION = gql(`
  mutation SudoClientMutation($publicClientId: Int!) {
    sudoClient(publicClientId: $publicClientId) {
      success
      authorizationToken
      href
    }
  }
`);

export const VIEW_PUBLIC_CLIENT_QUERY = gql(`
  query ViewPublicClient($id: Int!) {
    viewPublicClient(id: $id) {
      ...PublicClientListOutput
    }
  }
`);

export const VIEW_PUBLIC_COMPANY_QUERY = gql(`
  query ViewPublicCompany($id: Int!) {
    viewPublicCompany(id: $id) {
      ...PublicCompanyListShort
    }
  }
`);

export const UPDATE_PUBLIC_CLIENT_MUTATION = gql(`
  mutation UpdatePublicClient($id: Int!, $data: PublicClientInput!) {
    updatePublicClient(id: $id, data: $data) {
      ...PublicClientListOutput
    }
  }
`);

export const CREATE_PUBLIC_CLIENT_MUTATION = gql(`
  mutation CreatePublicClient($data: PublicClientInput!) {
    createPublicClient(data: $data) {
      ...PublicClientListOutput
    }
  }
`);

export const UPDATE_PUBLIC_COMPANY_MUTATION = gql(`
  mutation UpdatePublicCompany($id: Int!, $data: PublicCompanyInput!) {
    updatePublicCompany(id: $id, data: $data) {
      ...PublicCompanyListShort
    }
  }
`);

export const CREATE_PUBLIC_COMPANY_MUTATION = gql(`
  mutation CreatePublicCompany($data: PublicCompanyInput!) {
    createPublicCompany(data: $data) {
      ...PublicCompanyListShort
    }
  }
`);

export const DEACTIVATE_PUBLIC_CLIENT_MUTATION = gql(`
  mutation DeactivatePublicClient($id: Int!) {
    deactivatePublicClient(id: $id) {
      ...PublicClientListOutput
    }
  }
`);

export const REACTIVATE_PUBLIC_CLIENT_MUTATION = gql(`
  mutation ReactivatePublicClient($id: Int!) {
    reactivatePublicClient(id: $id) {
      ...PublicClientListOutput
    }
  }
`);

export const DEACTIVATE_PUBLIC_COMPANY_MUTATION = gql(`
  mutation DeactivatePublicCompany($id: Int!) {
    deactivatePublicCompany(id: $id) {
      ...PublicCompanyListShort
    }
  }
`);

export const REACTIVATE_PUBLIC_COMPANY_MUTATION = gql(`
  mutation ReactivatePublicCompany($id: Int!) {
    reactivatePublicCompany(id: $id) {
      ...PublicCompanyListShort
    }
  }
`);

export const RESEND_COMPANY_INVITATION_MUTATION = gql(`
  mutation ResendCompanyInvitation($clientId: Int!) {
    resendCompanyInvitation(clientId: $clientId)
  }
`);

export const LIST_USERS_FOR_SELECTION_QUERY = gql(`
  query ListUsersForSelection($spaceId: Int) {
    listUsers(spaceId: $spaceId) {
      users {
        id
        name
        email
      }
    }
  }
`);

export const LIST_KEY_ACCOUNT_MANAGERS_QUERY = gql(`
  query ListKeyAccountManagers {
    listKeyAccountManagers {
      id
      name
      email
    }
  }
`);

export const COMPANY_COMMENT_FRAGMENT = gql(`
  fragment CompanyCommentOutput on HL_CompanyCommentOutput {
    id
    description
    isBookingRelevant
    isContactRelevant
    contactType
    contactSubjectId
    contactSubject {
      id
      name
    }
    createdAt
    updatedAt
    createdBy {
      id
      name
      email
    }
    publicClient {
      id
      firstname
      lastname
    }
  }
`);

export const LIST_COMPANY_COMMENTS_QUERY = gql(`
  query ListCompanyComments($companyId: Int!, $clientId: Int) {
    listCompanyComments(companyId: $companyId, clientId: $clientId) {
      ...CompanyCommentOutput
    }
  }
`);

export const CREATE_COMPANY_COMMENT_MUTATION = gql(`
  mutation CreateCompanyComment($data: CompanyCommentInput!) {
    createCompanyComment(data: $data) {
      ...CompanyCommentOutput
    }
  }
`);

export const UPDATE_COMPANY_COMMENT_MUTATION = gql(`
  mutation UpdateCompanyComment($id: Int!, $data: CompanyCommentInput!) {
    updateCompanyComment(id: $id, data: $data) {
      ...CompanyCommentOutput
    }
  }
`);

export const DELETE_COMPANY_COMMENT_MUTATION = gql(`
  mutation DeleteCompanyComment($id: Int!) {
    deleteCompanyComment(id: $id) {
      ...CompanyCommentOutput
    }
  }
`);

export const LIST_CONTACT_SUBJECTS_QUERY = gql(`
  query ListContactSubjects($where: ContactSubjectWhereInput) {
    listContactSubjects(where: $where) {
      id
      name
      isActive
      createdAt
      updatedAt
    }
  }
`);

export const CREATE_CONTACT_SUBJECT_MUTATION = gql(`
  mutation CreateContactSubject($data: ContactSubjectInput!) {
    createContactSubject(data: $data) {
      id
      name
      isActive
      createdAt
      updatedAt
    }
  }
`);

export const UPDATE_CONTACT_SUBJECT_MUTATION = gql(`
  mutation UpdateContactSubject($id: Int!, $data: ContactSubjectInput!) {
    updateContactSubject(id: $id, data: $data) {
      id
      name
      isActive
      createdAt
      updatedAt
    }
  }
`);

export const DELETE_CONTACT_SUBJECT_MUTATION = gql(`
  mutation DeleteContactSubject($id: Int!) {
    deleteContactSubject(id: $id) {
      id
      name
      isActive
      createdAt
      updatedAt
    }
  }
`);

export const LIST_ACCOUNTING_AREAS = gql(`
  query ListAccountingAreas($publicCompanyId: Int) {
    listAccountingAreas(publicCompanyId: $publicCompanyId) {
      id
      name
      contactName
      bookingName
      attentionName
      invoiceEmail
      billingCompany
      billingStreet
      billingAddressAddition
      billingZip
      billingCity
      billingCountry
      billingComment
      vatId
      noVatIdReason
      commercialRegisterNumber
      taxId
      poId
      isDefault
      additionalEmailRecipients {
        id
        email
        name
      }
    }
  }
`);

export const UPDATE_ACCOUNTING_AREAS = gql(`
  mutation UpdateAccountingAreas($data: [AMAccountingAreaInput!]!, $publicCompanyId: Int!) {
    updateAccountingAreas(data: $data, publicCompanyId: $publicCompanyId) {
      id
      name
      contactName
      bookingName
      attentionName
      invoiceEmail
      billingCompany
      billingStreet
      billingAddressAddition
      billingZip
      billingCity
      billingCountry
      billingComment
      vatId
      noVatIdReason
      commercialRegisterNumber
      taxId
      poId
      isDefault
      additionalEmailRecipients {
        id
        email
        name
      }
    }
  }
`);

// User Groups Fragments and Queries
export const USER_GROUP_FRAGMENT = gql(`
  fragment UserGroupOutput on HL_UserGroupOutput {
    id
    name
    publicCompanyId
    createdAt
    updatedAt
    membersCount
  }
`);

export const USER_GROUP_MEMBER_FRAGMENT = gql(`
  fragment UserGroupMemberOutput on HL_UserGroupMemberOutput {
    id
    userGroupId
    publicClientId
    publicClient {
      ...PublicClientListShort
    }
  }
`);

export const LIST_USER_GROUPS_QUERY = gql(`
  query ListUserGroups($where: UserGroupWhereInput, $skip: Int, $take: Int) {
    listUserGroups(where: $where, skip: $skip, take: $take) {
      ...UserGroupOutput
    }
  }
`);

export const GET_USER_GROUP_QUERY = gql(`
  query GetUserGroup($id: Int!) {
    getUserGroup(id: $id) {
      ...UserGroupOutput
      members {
        ...UserGroupMemberOutput
      }
    }
  }
`);

export const CREATE_USER_GROUP_MUTATION = gql(`
  mutation CreateUserGroup($input: CreateUserGroupInput!) {
    createUserGroup(input: $input) {
      ...UserGroupOutput
    }
  }
`);

export const UPDATE_USER_GROUP_MUTATION = gql(`
  mutation UpdateUserGroup($input: UpdateUserGroupInput!) {
    updateUserGroup(input: $input) {
      ...UserGroupOutput
    }
  }
`);

export const DELETE_USER_GROUP_MUTATION = gql(`
  mutation DeleteUserGroup($id: Int!) {
    deleteUserGroup(id: $id) {
      ...UserGroupOutput
    }
  }
`);

export const UPDATE_USER_GROUP_MEMBERS_MUTATION = gql(`
  mutation UpdateUserGroupMembers($input: UserGroupMemberInput!) {
    updateUserGroupMembers(input: $input) {
      ...UserGroupOutput
    }
  }
`);
export const HOTEL_COMMENT_FRAGMENT = gql(`
  fragment HotelCommentOutput on Content_HotelCommentOutput {
    id
    description
    hotelId
    hotelContactId
    hotelContact {
      id
      firstname
      lastname
    }
    createdById
    createdBy {
      id
      name
      email
    }
    createdAt
    updatedAt
  }
`);

export const LIST_HOTEL_COMMENTS_QUERY = gql(`
  query ListHotelComments($hotelId: Int!) {
    listHotelComments(hotelId: $hotelId) {
      ...HotelCommentOutput
    }
  }
`);

export const CREATE_HOTEL_COMMENT_MUTATION = gql(`
  mutation CreateHotelComment($hotelId: Int!, $description: String!, $hotelContactId: Int) {
    createHotelComment(hotelId: $hotelId, description: $description, hotelContactId: $hotelContactId) {
      ...HotelCommentOutput
    }
  }
`);

export const UPDATE_HOTEL_COMMENT_MUTATION = gql(`
  mutation UpdateHotelComment($id: Int!, $description: String!, $hotelContactId: Int) {
    updateHotelComment(id: $id, description: $description, hotelContactId: $hotelContactId) {
      ...HotelCommentOutput
    }
  }
`);

export const DELETE_HOTEL_COMMENT_MUTATION = gql(`
  mutation DeleteHotelComment($id: Int!) {
    deleteHotelComment(id: $id)
  }
`);